import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HBox, VBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { Cell, List, Row } from '../../../components/List';
import { Camera, Times, Plus, Check, CircleTimes, EditSquare } from '../../../components/Icon';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { Button } from '../../../components/Buttons';
import { deleteVehicleProperty, setVehicleProperty, setVehicleProperties, downloadZipFiles } from '../actions';
import { addDocument, deleteDocument } from '../../Documents/actions';
import { resizeAndRotate } from '../../../utils/image';
import { selectWork } from '../../Api/selectors';
import { Loader } from '../../../components/Loader';
import {
  REQUEST_VEHICLE_PROPERTY_UPDATE,
  WS2_1_IMPORT_PHOTOS_COMMERCIAL,
  WS2_1_IMPORT_PHOTOS_PASSENGER,
} from '../constants';
import cn from 'classnames';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import styles from './VehicleInspectionCardv2.module.css';
import ImageCarouselComponent from '../../../containers/App/Components/Carousel/Carousel';
import { VehiclePropertyLoadable } from './VehiclePropertyLoadable';
import { getIncidentOptions } from '../helpers';
import { SearchSelect } from '../../../components/SearchSelectComponent';
import { COLOR_PRIMARY_1 } from '../../../vars';
import { REQUEST_DELETE_DOCUMENT } from '../../Users/constants';
import { isMobileDevice } from '../../../utils/checkDevice';

const Container = styled.div`
  max-width: 1280px;
  .icon-edit-square {
    cursor: pointer;
    color: #d9d9d9;
  }

  .subtitle-block {
    width: 30%;
    &.basic-multi-select {
      width: 100%;
    }
  }
  .image {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 300px;
    min-width: 300px;
    height: 300px;
    min-height: 300px;
    &.large {
      width: 700px;
      min-width: 700px;
      height: 400px;
      min-height: 400px;
    }

    &.thumb {
      width: 200px;
      height: 180px;
      min-width: 200px;
      min-height: 180px;
    }

    &.incident-detail {
      width: 120px;
      height: 90px;
      min-width: 120px;
      min-height: 90px;
    }
  }

  font-size: 14px;
  /* margin: 10px auto; */
  // max-width: 770px;
  max-width: 100%;

  .button.inactive {
    opacity: 0.4;
  }

  .cell:first-child {
    text-transform: capitalize;
  }

  .info-cell {
    white-space: nowrap;
  }

  .attention-img {
    width: 100px;
    height: 100px;
    flex-shrink: 0;
    background-size: contain;
    border: 1px solid black;
    background-position: center center;
    .add {
      width: 100px;
      height: 100px;
    }
  }
`;

const Subtitle = styled.h3`
  width: 100%;
  background: #eff1f7;
  font-weight: bold;
  padding: 4px;
  font-size: 14px;
`;

const StateToggler = styled.div`
  min-height: 24px;
  width: ${props => (props.small ? '110px' : '160px')};
  border-radius: 12px;
  background-color: ${({ isActive }) => (!!isActive ? 'var(--color-new-secondary)' : '#fa5c7c')};
  color: white;
  font-weight: bold;
  padding: 0 2px;
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: 0;
`;
const PhotoWrapper = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => (props.isActive ? 'white' : 'grey')};
  background-color: ${props => (props.isActive ? 'var(--color-new-secondary)' : 'var(--color-new-white)')};
`;

const ShowButton = styled.span`
  font-weight: bold;
  font-size: 12px;
  color: #0183d5;
  opacity: ${props => (props.disabled ? '0.7' : '1')};
  text-decoration: underline;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  margin-left: 12px;
`;

const Table = styled.div`
  display: table;
  width: 100%;

  > div {
    display: table-row;
    > div {
      display: table-cell;
      padding: 12px;
      border-bottom: 1px solid #ddd;

      white-space: nowrap;

      &:first-child {
        max-width: 100px;
        font-size: 12px;
        font-weight: 400;
        color: black;
      }

      &:last-child,
      &.header {
        width: 15%;
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        color: black;
      }

      &:last-child {
        max-width: 180px;
        overflow: hidden;
        ,
        span {
          white-space: wrap;
        }
      }

      &.option-name {
        text-align: left;
        color: #999;
      }

      &.option-title {
        text-align: left;
      }
    }
    &:last-child {
      > div {
        border-bottom: none;
      }
    }
  }
`;

const ImportCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  span {
    color: #808185;
    font-weight: 600;
    text-align: center;
  }

  .icon-wrapper {
    cursor: pointer;
    position: absolute;
    top: 8px;
    right: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;

    background-color: #d50046;
    color: #fff;

    svg {
      vertical-align: middle;
    }
  }
`;

const AttentionImage = styled.img`
  width: 150px;
  height: 150px;

  @media (max-width: 768px) {
    width: 100px;
    height: 100px;
  }
`;

const Pane = styled.div`
  border: px solid grey;
  // background: #eff1f7;

  .title {
    font-size: 12px;
    color: black;
    text-transform: uppercase;
    font-weight: 400;
    line-height: 24px;
  }

  .sub-title {
    margin-top: 20px;
    color: black;
    text-transform: capitalize;
    font-weight: 600;
  }

  .reset {
    cursor: pointer;
    text-decoration: underline;
    color: ${COLOR_PRIMARY_1};
  }
  .info {
    font-size: 14px;
    font-weight: 400;
    color: black;
    max-width: 100%;
  }

  padding: 16px;
`;

const AttentionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  padding: 8px 0;

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }
`;

const TiresCell = styled(Cell)`
  width: 25%;
`;

const STATE = {
  showImagesModal: false,
  group: null,
  comment: '',
  showCarousel: false,
  carouselImages: [],
  carouselTitle: null,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleInspectionCardv2Comp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (this.props.isFromKanban) {
      this.scrollToInspection();
    }
  }

  get vehicle() {
    return this.props.vehicle || this.props.cell.vehicle;
  }

  scrollToInspection() {
    const VehicleInspectionCardv2 = document.getElementById('VehicleInspectionCardv2');

    if (VehicleInspectionCardv2) {
      VehicleInspectionCardv2.scrollIntoView({ behavior: 'smooth' });
    }
  }

  getAllOptions(attentionType, propertyName) {
    const options = getIncidentOptions(attentionType, this.lbl);
    return options;
  }

  getIncidentPropertyValue(incident, prop) {
    const targetIncident = this.incidents?.find(i => i?.id === incident?.id);
    const label = this.getAllOptions(targetIncident.attentionType)?.[prop]?.find(i => i.value == targetIncident[prop]);
    return label;
  }

  getFieldValue(fieldName) {
    if (Object.keys(this.state).includes(fieldName)) {
      return this.state[fieldName];
    }
    return +this.vehicle[fieldName];
  }

  downloadImages(imagesURLs) {
    this.setState({ downloadImages: true }, () => {
      this.props.downloadZip(imagesURLs, result => {
        this.setState({ downloadImages: false });
        window.open('/storage/zip/' + this.vehicle.id + '.zip');
      });
    });
  }

  onPropertyChange(incident, prop, value, callback) {
    const targetIncident = this.incidents?.find(i => i?.id === incident?.id);

    this.props.setProperty(
      'inspection_attention_incident_' + incident?.id,
      JSON.stringify({ ...targetIncident, [prop]: value }),
      callback,
    );
  }

  propertyValue(name) {
    return this.vehicle[name];
  }

  renderOptionPhoto() {
    if (!this.state.renderOptionPhoto) return null;

    return (
      <ModalComponent
        size="lg"
        onClose={() => {
          this.setState({ renderOptionPhoto: null, renderPhotoUrl: null });
        }}
      >
        <div
          onClick={() => this.setState({ renderOptionPhoto: null, renderPhotoUrl: null })}
          style={{
            margin: '0 auto',
            width: window.innerWidth > 768 ? 500 : '90%',
            height: window.innerWidth > 768 ? 500 : 300,
            backgroundImage: `url('${encodeURI(decodeURI(this.state.renderPhotoUrl)).replace(/%5C/g, '/')}')`,
            backgroundSize: 'contain',
            backgroundPosition: 'center center',
          }}
        />

        {/*<div className="img" style={{ backgroundImage: `url('${document.url}')`, width: 300, height: 'auto'}}></div>*/}
      </ModalComponent>
    );
  }

  handleOpenPhoto = photo => {
    this.setState({
      renderOptionPhoto: photo.id,
      renderPhotoUrl: photo.url,
    });
  };

  renderTiresSet = setName => {
    const [weather, material, inch, lf, rf, lb, rb] = this.vehicle[setName].split(':');
    return (
      <>
        <Subtitle>{this.lbl('vehicle.property.tires')}</Subtitle>
        <List>
          <Row key={`${setName}_lf`}>
            <TiresCell>{this.lbl('vehicle.tires.lf')}</TiresCell>
            <TiresCell>{lf} mm</TiresCell>
            <TiresCell>{this.lbl(`vehicle.tires.${weather}`)}</TiresCell>
            <TiresCell>{this.lbl(`vehicle.tires.${material}`)}</TiresCell>
          </Row>
          <Row key={`${setName}_lb`}>
            <TiresCell>{this.lbl('vehicle.tires.lb')}</TiresCell>
            <TiresCell>{lb} mm</TiresCell>
            <TiresCell>{this.lbl(`vehicle.tires.${weather}`)}</TiresCell>
            <TiresCell>{this.lbl(`vehicle.tires.${material}`)}</TiresCell>
          </Row>
          <Row key={`${setName}_rf`}>
            <TiresCell>{this.lbl('vehicle.tires.rf')}</TiresCell>
            <TiresCell>{rf} mm</TiresCell>
            <TiresCell>{this.lbl(`vehicle.tires.${weather}`)}</TiresCell>
            <TiresCell>{this.lbl(`vehicle.tires.${material}`)}</TiresCell>
          </Row>
          <Row key={`${setName}_rb`}>
            <TiresCell>{this.lbl('vehicle.tires.rb')}</TiresCell>
            <TiresCell>{rb} mm</TiresCell>
            <TiresCell>{this.lbl(`vehicle.tires.${weather}`)}</TiresCell>
            <TiresCell>{this.lbl(`vehicle.tires.${material}`)}</TiresCell>
          </Row>
        </List>
      </>
    );
  };

  renderInspectionProperty(name, hasPhoto = false) {
    let val = this.propertyValue(name);
    let state = val == 1 ? 1 : val == 2 ? 2 : 0;
    let photo = this.vehicle.documents?.find(document => document.type == 'photo_interior_' + name);
    let isWithPhoto = hasPhoto && photo?.id;
    const isOk = state === 1;
    return (
      !!state && (
        <Row className={styles.row} key={name}>
          {this.renderOptionPhoto()}
          <Cell className={styles.cell1}>
            <VBox left>
              {this.lbl(`vehicle.property.${name}`)}
              <strong>{this.vehicle[`${name}_comment`]}</strong>
            </VBox>
          </Cell>
          {!!isWithPhoto && (
            <Cell className={styles.cell3}>
              <PhotoWrapper
                isActive={!!photo}
                className={cn('pointer image-available', styles.buttonCameraPhoto)}
                onClick={() => {
                  if (!!photo) this.handleOpenPhoto(photo);
                }}
              >
                <Camera />
              </PhotoWrapper>
            </Cell>
          )}
          <Cell className={styles.cell2}>
            <StateToggler isActive={isOk} small={isWithPhoto}>
              <FontAwesomeIcon icon={isOk ? faCheckCircle : faTimesCircle} style={{ width: 22, marginRight: 5 }} />
              {isWithPhoto
                ? isOk
                  ? this.lbl('vehicle.inspection.present')
                  : this.lbl('vehicle.inspection.flaw')
                : isOk
                ? this.lbl('vehicle.inspection.checked')
                : this.lbl('vehicle.inspection.failed')}
            </StateToggler>
          </Cell>
        </Row>
      )
    );
  }

  toggleCheckbox = name => {
    // this.props.setProperty(name, !!(+this.vehicle[name]) ? 0 : 1);
    if (!!this.props.loadingChecks) return;
    const val = +this.getFieldValue(name);
    this.setState({ [name]: val ? 0 : 1 });
  };

  toggleShowRepaired = () => {
    const toggleValue = this.vehicle.showRepaired === 'false' ? true : !this.vehicle.showRepaired;
    this.props.setProperty('showRepaired', toggleValue);
    this.setState(state => ({ showRepaired: toggleValue }));
  };

  toggleAttentionPhotos = group => {
    if (!this.state.showImagesModal) {
      this.setState({ showImagesModal: true, group, comment: this.vehicle[`attention_comment_${group?.id}`] ?? '' });
    } else {
      this.setState({ showImagesModal: false, group: null });
    }
  };

  addAttentionImage(index) {
    this.capture('attention_' + index);
  }

  handleIncidentPhotoDelete = documentId => {
    this.props.deleteDocument(documentId, this.setStateFn({ currentImageUrl: null }));
  };

  handlePhotoDelete = documentId => {
    const images = this.vehicle.documents?.filter(d => d?.type === `photo_interior_attention_${this.state.group.id}`);
    if (images?.length === 1) {
      const index = this.state.group?.id;
      this.props.deleteProperty(`attention_comment_${index}`);
      this.props.deleteProperty(`attention_repaired_${index}`);
      this.props.deleteProperty(`attention_displayed_${index}`);
      this.props.deleteDocument(documentId, () => {
        this.setState({
          group: null,
          showImagesModal: false,
          comment: '',
        });
      });
    } else if (this.state.group?.type === 'photo_interior_attention') {
      this.props.deleteProperty(`attention_repaired_${documentId}`);
      this.props.deleteProperty(`attention_displayed_${documentId}`);
      this.props.deleteDocument(documentId, () => {
        this.setState({
          group: null,
          showImagesModal: false,
          comment: '',
        });
      });
    } else {
      this.props.deleteDocument(documentId, () => {
        this.setState(state => ({
          group: { ...state?.group, photos: images?.filter(p => p.id !== documentId) },
        }));
      });
    }
  };

  handleImportPhotoDelete = id => {
    this.props.deleteDocument(id, () => {});
  };

  capture(name, callback) {
    //remove existing image upload
    document.getElementById('image-upload')?.remove();

    let input = document.createElement('input');
    input.type = 'file';
    input.name = 'image';
    input.id = 'image-upload';
    input.accept = 'image/*';
    // input.setAttribute('capture', 'camera');

    if (isMobileDevice()) {
      input.setAttribute('capture', 'environment');
    }

    document.body.appendChild(input);

    input.click();

    input.addEventListener(
      'change',
      this.callback(evt => {
        resizeAndRotate(evt.target.files[0]).then(file => {
          this.props.imageUpload(
            {
              name,
              type: 'photo_interior_' + name,
              originalFilename: 'originalFilename',
              file: evt.target.files[0],
            },
            'upload_' + name,
          );

          callback?.();

          try {
            evt.target.removeEventListener(evt.target, this._evtListener);
            evt.target.remove();
          } catch (e) {}
        });
      }),
    );
  }

  onCommentChange = e => {
    const { value } = e.target;
    this.setState({ comment: value });
  };

  isChecked = (fieldName, defaultValue = false) => {
    return +this.getFieldValue(fieldName) ?? defaultValue;
  };

  openCarousel = (images, current, title) => {
    if (current) {
      let currentIndex = images.map(image => image?.id).indexOf(current[0]?.id);
      const firstPart = images?.slice(currentIndex);
      const secondPart = images?.slice(0, currentIndex);

      this.setState({ showCarousel: true, carouselImages: [...firstPart, ...secondPart] ?? [], carouselTitle: title });

      return;
    }
    this.setState({ showCarousel: true, carouselImages: images ?? [], carouselTitle: title });
  };

  closeCarousel = () => {
    this.setState({ showCarousel: false, carouselImages: [], carouselTitle: null });
  };

  onCheckboxesSave = () => {
    const params = Object.keys(this.state)?.filter(
      p => p?.startsWith('attention_repaired') || p?.startsWith('attention_displayed'),
    );

    const checksProperties = params?.map(param => ({
      propertyName: param,
      propertyValue: this.state[param] ?? 0,
    }));
    this.props.setVehicleProperties(checksProperties);
  };

  renderImportPhotos = () => {
    let photoDocs = [];
    let photoGroup = [];
    let defaults = [];
    let URLs = [];

    const getCurrent = currentId => {
      let current = photoGroup.filter(image => image?.id == currentId);

      return current;
    };

    if (this.vehicle?.vehicle_purpose === 'passenger') {
      defaults = WS2_1_IMPORT_PHOTOS_PASSENGER;
    }
    if (this.vehicle?.vehicle_purpose === 'commercial') {
      defaults = WS2_1_IMPORT_PHOTOS_COMMERCIAL;
    }

    defaults?.map((type, i) => {
      let photos = this.vehicle?.documents?.filter(d => {
        return d?.type?.indexOf(`photo_interior_import_0 ${type}`) === 0;
      });

      if (!photos?.length) return;

      photoGroup.push(photos[0]);
      URLs.push(photos[0]?.url);
      return photoDocs.push({
        index: i,
        placeholder: type,
        photos,
      });
    });
    return (
      <>
        <Subtitle style={{ display: 'flex', justifyContent: 'space-between' }}>
          {this.lbl('interior.inspection.import_photo')}
          <ShowButton disabled={!URLs?.length || this.state.downloadImages} onClick={() => this.downloadImages(URLs)}>
            {this.state.downloadImages ? <Loader small /> : this.lbl('download')}
          </ShowButton>
        </Subtitle>

        <AttentionsContainer>
          {photoDocs?.map(
            doc =>
              doc?.photos[0]?.url && (
                <ImportCard key={doc?.placeholder}>
                  <div className="icon-wrapper" onClick={() => this.handleImportPhotoDelete(doc?.photos[0]?.id)}>
                    <Times />
                  </div>
                  <AttentionImage
                    src={doc?.photos[0]?.url}
                    width={200}
                    onClick={() => this.openCarousel(photoGroup, getCurrent(doc?.photos[0]?.id))}
                  />
                  <span>{this.lbl(`vehicle.import_photos.${doc?.placeholder}`)}</span>
                </ImportCard>
              ),
          )}
        </AttentionsContainer>
      </>
    );
  };

  inspectionIncidentPhotos(incidentId, allIncidents) {
    if (allIncidents) {
      let photos = this.vehicle?.documents?.filter(d => {
        return d?.type?.includes(`photo_interior_inspection_incident_`);
      });

      if (!photos?.length) return;

      return photos;
    }
    let result = this.vehicle.documents?.filter(
      document => document.type == `photo_interior_inspection_incident_${incidentId}`,
    );
    return result;
  }

  setCurrentImage = img => {
    this.setState({ currentImageUrl: img });
  };

  renderPhotoCarousel1 = incidentId => {
    const currentImage = this.state.currentImageUrl;
    if (this.props.workDelete)
      return (
        <ModalComponent onClose={this.setStateFn({ currentImageUrl: null })} title="Layer toevoegen" size="xl">
          <HBox center>
            <Loader small />
          </HBox>
        </ModalComponent>
      );
    return (
      <ModalComponent onClose={this.setStateFn({ currentImageUrl: null })} title="Layer toevoegen" size="xl">
        <div>
          <img src={currentImage?.url ?? ''} alt="Vehicle general image" style={{ objectFit: 'contain', width: '100%' }} />
        </div>
        <ButtonComponent style="ButtonSoftDelete" onClick={() => this.handleIncidentPhotoDelete(currentImage?.id)}>
          <Times />
          {this.lbl('delete')}
        </ButtonComponent>
      </ModalComponent>
    );
  };

  renderImage(doc, className, key, index) {
    console.log('doc', doc.url); // Log before returning JSX
    const photoGroup = this.inspectionIncidentPhotos(null, true);

    const getCurrent = currentId => {
      let current = photoGroup.filter(image => image?.id == doc.id);

      return current;
    };

    return (
      <div
        key={`${key}-${doc.url}`}
        className={`image ${className || ''}`}
        style={{ backgroundImage: `url('${encodeURI(decodeURI(doc?.url)).replace(/%5C/g, '/')}')` }}
        onClick={() => this.openCarousel(photoGroup, getCurrent())}
      ></div>
    );
  }

  renderEditableProp(incident, prop, key) {
    if (this.state.editProp === `${incident?.id}_${prop}`) {
      switch (prop) {
        case 'solution':
        case 'type':
        case 'part':
          return (
            <SearchSelect
              key={key}
              onChange={e => {
                this.onPropertyChange(incident, prop, e.value, this.setStateFn({ editProp: null, editIncident: null }));
              }}
              value={this.getIncidentPropertyValue(incident, prop)}
              options={this.getAllOptions(incident.attentionType)?.[prop]}
            />
          );
        case 'cost':
        case 'remarks':
          return (
            <input
              className="form-control"
              value={this.state[prop]}
              onChange={evt =>
                this.setState({
                  [prop]: prop === 'cost' ? evt.target.value.replace(/[^0-9]/g, '') : evt.target.value,
                })
              }
              onBlur={() => {
                this.state[prop] &&
                  this.onPropertyChange(
                    incident,
                    prop,
                    this.state[prop],
                    this.setStateFn({ editProp: null, editIncident: null, [prop]: null }),
                  );
              }}
            />
          );
        default:
          '';
      }
    }

    if (prop === 'part') {
      return (
        <div className="sub-title">
          Schade {incident.part}{' '}
          <EditSquare
            onClick={() => {
              this.setState({ editProp: `${incident?.id}_${prop}`, editIncident: incident?.id });
            }}
          />
        </div>
      );
    }

    return (
      <div key={`i-${incident.id}-${prop}`}>
        {incident[prop]}
        <EditSquare
          onClick={() => {
            this.setState({ editProp: `${incident?.id}_${prop}`, editIncident: incident?.id });
          }}
        />
      </div>
    );
  }

  renderBooleanValue(incident, prop, value, key) {
    const targetIncident = this.incidents?.find(i => i?.id === incident?.id);

    return (
      <div key={key}>
        <div className="d-flex gap-2">
          <VehiclePropertyLoadable>
            <div className={!targetIncident?.[prop] ? 'opacity-25' : ''}>
              <Button
                primary
                small
                onClick={() =>
                  this.props.setProperty(
                    'inspection_attention_incident_' + incident?.id,
                    JSON.stringify({ ...targetIncident, [prop]: true }),
                  )
                }
              >
                {this.lbl('yes')}
              </Button>
            </div>
          </VehiclePropertyLoadable>
          <VehiclePropertyLoadable>
            <div className={targetIncident?.[prop] ? 'opacity-25' : ''}>
              <Button
                warning
                small
                onClick={() =>
                  this.props.setProperty(
                    'inspection_attention_incident_' + incident?.id,
                    JSON.stringify({ ...targetIncident, [prop]: false }),
                  )
                }
              >
                {this.lbl('no')}
              </Button>
            </div>
          </VehiclePropertyLoadable>
        </div>
      </div>
    );
  }

  get incidents() {
    let result = Object.keys(this.vehicle)
      .filter(name => name.indexOf('inspection_attention_incident_') === 0)
      .map(key => this.vehicle[key]);

    return result;
  }

  //get all acceptable / not acceptable incidents
  inspectionIncidents(acceptable, sum) {
    const result = this.incidents;

    if (sum) {
      result = _.sumBy(result, i => parseInt(i.cost?.replace(/\D/g, ''), 10));
      return `€ ${result},00`;
    }

    return result.map(incident => ({
      ...incident,
      type: incident.type ? this.lbl(`inspection.attention.type.${incident.type}`) : '',
      solution: incident.solution ? this.lbl(`inspection.attention.solution.${incident.solution}`) : '',
      part: incident.part ? this.lbl(`inspection.attention.part.${incident.part}`) : '',
      cost: incident.cost ? `€ ${incident.cost},00` : '',
      acceptable: incident.acceptable ? this.lbl(`inspection.attention.acceptable.${incident.acceptable}`) : '',
      commercial: incident.commercial ? this.lbl(`inspection.attention.commercial.${incident.commercial}`) : '',
      repaired: incident.repaired ? this.lbl(`inspection.attention.commercial.${incident.repaired}`) : '',
    }));
  }

  renderAttentions = () => {
    const photos = this.vehicle.documents?.filter(d => d?.type?.startsWith('photo_interior_attention_'));
    const groups = Array.from(new Set(photos?.map(photo => photo.type?.slice(25))))?.map(group => ({
      id: group,
      comment: this.vehicle[`attention_comment_${group}`] ?? '-',
      isRepaired: this.vehicle[`attention_repaired_${group}`] == 1,
      photos: photos.filter(photo => photo?.type === `photo_interior_attention_${group}`),
    }));
    const separatePhotos = this.vehicle.documents?.filter(d => d?.type === 'photo_interior_attention');

    var group = {};

    return (
      <>
        <Subtitle>{this.lbl('interior.inspection.damages')}</Subtitle>
        <AttentionsContainer className={styles.attentionsContainer}>
          <Pane style={{ width: '100%' }}>
            {this.inspectionIncidents(false).map(incident => (
              <div style={{ borderBottom: '5px solid #EFF1F7' }} key={`inspection-incident-detailed-${incident.id}`}>
                <HBox vBottom>
                  <div className="subtitle-block">{this.renderEditableProp(incident, 'part', `i-${incident.id}-part`)}</div>

                  {this.state.editIncident == incident?.id && (
                    <span
                      className="reset"
                      onClick={() =>
                        this.setState({
                          editProp: null,
                          editIncident: null,
                        })
                      }
                    >
                      {this.lbl('reset')}
                    </span>
                  )}
                </HBox>
                <Table>
                  <div>
                    {['type', 'solution', 'cost', 'acceptable', 'commercial', 'repaired'].map(name => (
                      <div key={name} className="header">
                        {this.lbl(`inspection.attention.${name}`)}
                      </div>
                    ))}
                  </div>
                  <div>
                    {['type', 'solution', 'cost'].map(prop => {
                      return this.renderEditableProp(incident, prop, `i-${incident.id}-${prop}`);
                    })}
                    {['acceptable', 'commercial', 'repaired'].map(prop => {
                      return this.renderBooleanValue(incident, prop, incident[prop], `i-${incident.id}-${prop}-boolean`);
                    })}
                  </div>
                </Table>
                Opmerking: <div>{this.renderEditableProp(incident, 'remarks', `i-${incident.id}-remarks`)}</div>
                <HBox flexWrap gap={12} left>
                  <HBox flexWrap gap={12} left>
                    {console.log('incident', incident.id)}
                    {this.state.currentImageUrl && <div key={incident.id}>{this.renderPhotoCarousel1(incident?.id)}</div>}
                    {this.inspectionIncidentPhotos(incident.id)?.map((doc, index) => {
                      return this.renderImage(doc, 'incident-detail', `incident-detail-${incident.id}`, incident.id);
                    })}
                  </HBox>
                </HBox>
                <div>
                  <br />
                </div>
              </div>
            ))}
          </Pane>
        </AttentionsContainer>

        <HBox left vCenter gap={10}>
          <Button
            className={styles.buttonSave}
            isPrimary
            small
            disabled={this.props.loadingChecks}
            onClick={this.onCheckboxesSave}
          >
            {!!this.props.loadingChecks && <Loader small />}
            {this.lbl('save')}
          </Button>
        </HBox>
      </>
    );
  };

  renderPhotosModal = () => {
    const images = !this.state.group?.type
      ? this.vehicle.documents?.filter(d => d?.type === `photo_interior_attention_${this.state.group.id}`)
      : [this.state.group];

    return (
      <ModalComponent
        size="lg"
        onClose={() => {
          this.setState({ group: null, showImagesModal: false });
        }}
      >
        <Container>
          {!this.state.group?.type && (
            <div className={styles.buttonGroup}>
              <div className={styles.input}>
                <input
                  key={`attention-comment-${this.state.group.id}`}
                  name={`attention_comment_${this.state.group.id}`}
                  onChange={this.onCommentChange}
                  value={this.state.comment ?? this.vehicle[`attention_comment_${this.state.group.id}`] ?? ''}
                  className="form-control"
                />
              </div>

              <div className={styles.buttons}>
                <ButtonComponent
                  style={'ButtonSoftPrimary'}
                  onClick={() => {
                    this.props.setProperty(`attention_comment_${this.state.group.id}`, this.state.comment);
                  }}
                >
                  <Check />
                </ButtonComponent>

                <ButtonComponent
                  style={'ButtonSoftDelete'}
                  onClick={() => {
                    this.setState(
                      { comment: '', [`attention_comment_${this.state.group.id}`]: '' },
                      this.props.deleteProperty(`attention_comment_${this.state.group.id}`),
                    );
                  }}
                >
                  <CircleTimes />
                </ButtonComponent>
              </div>
            </div>
          )}
          <HBox className="gap-2" vCenter flip={window.innerWidth <= 768}>
            {images.map(photo => (
              <div
                key={`mod_photo_${photo?.id}`}
                style={{ border: '1px solid #d9d9d9', padding: 5, width: window.innerWidth > 768 ? '25%' : '80%' }}
              >
                <ButtonComponent style="ButtonSoftDelete" onClick={() => this.handlePhotoDelete(photo?.id)}>
                  <Times />
                  {this.lbl('delete')}
                </ButtonComponent>
                <div
                  style={{
                    margin: '15px auto',
                    width: '100%',
                    height: 200,
                    backgroundImage: `url('${encodeURI(decodeURI(photo?.url)).replace(/%5C/g, '/')}')`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'center center',
                  }}
                />
              </div>
            ))}
            {images.length < 4 && images[0]?.type !== 'photo_interior_attention' && (
              <div className="thumb attention-img">
                <VBox className="add" center vCenter onClick={() => this.addAttentionImage(this.state.group?.id)}>
                  <Plus />
                </VBox>
              </div>
            )}
          </HBox>
        </Container>
      </ModalComponent>
    );
  };
  renderPhotoCarousel = () => {
    const title = this.state.carouselTitle ? this.state.carouselTitle : this.lbl('interior.inspection.attention');
    if (this.props.workDelete)
      return (
        <ModalComponent onClose={this.setStateFn({ currentImageUrl: null })} title="Layer toevoegen" size="xl">
          <HBox center>
            <Loader small />
          </HBox>
        </ModalComponent>
      );
    return (
      <ModalComponent size="lg" onClose={this.closeCarousel} title={title}>
        <ImageCarouselComponent
          imgURLs={this.state.carouselImages}
          // onDeleteImg={this.handleIncidentPhotoDelete}
        />
      </ModalComponent>
    );
  };

  render() {
    const vehicle = this.vehicle;
    return (
      <Card className={cn('vehicle-info-card info-card data wide', styles.card)} style={{ width: '100%' }}>
        <Container id={'VehicleInspectionCardv2'}>
          {vehicle.action_ws2_interior_inspection_done != '1' ? (
            <>
              <HBox vCenter left>
                <VBox>
                  <h2 className="card-title mb-1 text-muted">{this.lbl('vehicle.details.inspection_not_done')}</h2>
                </VBox>
                <HBox right gap={'12px'}>
                  <div>
                    <Button className={styles.button} onClick={this.tofn(`/boards/1/action-page/${vehicle.id}`)}>
                      {this.lbl('vehicle.linktree.inspecteren')}
                    </Button>
                  </div>
                </HBox>
              </HBox>
            </>
          ) : (
            <>
              <HBox vCenter left>
                <VBox>
                  <h2 className="card-title mb-1 text-muted">{this.lbl('vehicle.details.inspection')}</h2>
                </VBox>
                <HBox right>
                  <div>
                    <Button className={styles.button} onClick={this.tofn(`/boards/1/action-page/${vehicle.id}`)}>
                      {this.lbl('vehicle.linktree.inspecteren')}
                    </Button>
                  </div>
                </HBox>
              </HBox>

              <HBox flip={window.innerWidth <= 768} gap="10px">
                <VBox>
                  <Subtitle>{this.lbl('vehicle.inspection.description')}</Subtitle>
                  <List>
                    {[
                      'date_last_maintenance',
                      'mileage_last_maintenance',
                      'date_timing_belt_change',
                      'mileage_timing_belt_change',
                      'num_keys',
                    ].map(property => {
                      if (
                        vehicle[property] &&
                        ['mileage_last_maintenance', 'mileage_timing_belt_change'].includes(property)
                      ) {
                        return (
                          <Row className={styles.row} key={property}>
                            <Cell className={styles.cell1}>{this.lbl(`vehicle.property.${property}`)}</Cell>
                            <Cell className={styles.cell2}>{+vehicle[property]} km</Cell>
                          </Row>
                        );
                      }

                      return (
                        <Row className={styles.row} key={property}>
                          <Cell className={styles.cell1}>{this.lbl(`vehicle.property.${property}`)}</Cell>
                          <Cell className={styles.cell2}>{vehicle[property]}</Cell>
                        </Row>
                      );
                    })}
                  </List>
                </VBox>
                <VBox>
                  <Subtitle>{this.lbl('vehicle.inspection.description')}</Subtitle>
                  <List>
                    {[
                      'has_instruction_book',
                      'has_maintenance_book',
                      'has_digital_maintenance',
                      'has_drivers_map',
                      'has_trekhaak',
                      'has_headrests',
                      'has_hatrest',
                      'warranty_sticker',
                      'has_charge_cable',
                      'has_charge_cable_230v',
                      'has_charge_cable_380v',
                      'has_charge_port',
                    ].map(property => this.renderInspectionProperty(property, true))}
                  </List>
                </VBox>
              </HBox>

              <VBox>
                {this.vehicle?.properties
                  ?.filter(p => p?.propertyName?.name?.startsWith('tire_set_'))
                  ?.map(ts => this.renderTiresSet(ts.propertyName?.name))}
                {this.renderAttentions()}
                {this.state.showImagesModal && this.renderPhotosModal()}
                {/* {this.renderImportPhotos()} */}

                {this.state.showCarousel && this.renderPhotoCarousel()}
              </VBox>
            </>
          )}
        </Container>
      </Card>
    );
  }
}

VehicleInspectionCardv2Comp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  vehicle: PropTypes.object,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loadingChecks: selectWork(REQUEST_VEHICLE_PROPERTY_UPDATE),
    workDelete: selectWork(REQUEST_DELETE_DOCUMENT),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setProperty(name, value, callback) {
      dispatch(
        setVehicleProperty(ownProps.vehicle.id, name, value, callback, {
          loadingProperty: true,
        }),
      );
    },
    setVehicleProperties(params) {
      dispatch(setVehicleProperties(ownProps.vehicle.id, params));
    },
    deleteProperty(name) {
      dispatch(deleteVehicleProperty(ownProps.vehicle.id, name));
    },
    imageUpload(documentDto, work, callback) {
      dispatch(addDocument(ownProps.vehicle.id, 'vehicle', documentDto, callback, work));
    },
    deleteDocument(id, callback) {
      dispatch(deleteDocument(ownProps.vehicle.id, 'vehicle', id, callback));
    },
    downloadZip(files, callback) {
      dispatch(downloadZipFiles(ownProps.vehicle?.id, files, callback));
    },
    setValueInspection(val) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'show_inspection_on_sales_website', val));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'show_inspection_on_sales_website_date', todaydate));
    },
    unsetValue() {
      dispatch(deleteVehicleProperty(ownProps.vehicle.id, 'show_on_sales_website'));
    },
    setValue(val) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'show_on_sales_website', val));
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'show_on_sales_website_date', todaydate));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleInspectionCardv2 = compose(withConnect, withRouter, injectIntl)(VehicleInspectionCardv2Comp);
